<template>
    <div class="heatmapwrapper">
        <BarComponent :data="data" :options="barOptions" />
    </div>
</template>
<script>
import 'chart.js/auto';
import { Bar as BarComponent } from 'vue-chartjs';


export default {
    name: 'heatmapchart',
    components: { BarComponent },
    props: ['chartdata','labels'],
    data() {
        return {
            data: {
                labels: [
                this.$t('scdda_evaluation.heatmap.value_5_very_high'),
                this.$t('scdda_evaluation.heatmap.value_4_high'),
                this.$t('scdda_evaluation.heatmap.value_3_medium'),
                this.$t('scdda_evaluation.heatmap.value_2_low'),
                this.$t('scdda_evaluation.heatmap.value_1_very_low'),
                this.$t('scdda_evaluation.heatmap.value_na'),
                ],
                datasets: [
                    { 
                        backgroundColor: ['red', 'red', 'yellow', 'green', 'green', 'gray'],
                        data: this.chartdata,
                        tooltiplabels: this.labels, 
                    },
                ],
            },
            barOptions: {
                responsive: true,
                maintainAspectRatio: false,
                indexAxis: 'y',
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        callbacks: {
                            label: function(context) {
                                return context.dataset.tooltiplabels[context.dataIndex];
                            },
                        }
                    },
                },
            },
        }
    },
}

</script>
